import React, { Fragment } from 'react';
import instagram from '../../assets/img/icon-instagram.png';
import facebook from '../../assets/img/icon-face.png';

import logoUXMob from '../../assets/img/logo-uxmob-assinatura.png';
import './Footer.css';
import ScrollTo from '../../helpers/scroll';
import Modal from '../Modal';

export default class Footer extends React.Component {

    constructor(props) {
        super(props);


        this.handlerLinkto.bind(this);
        this.handlerLinktoPage.bind(this);

        if (this.props.history.location.state !== undefined) {
            const { componentId } = this.props.history.location.state;

            if (componentId) {
                console.log(componentId);
                setTimeout(() => ScrollTo(componentId), 1000);
            }
        }
        this.state = {
            openModal: false
        }
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
    }

    handlerLinktoPage(pathPage) {

        this.props.history.push(pathPage);

    }

    handlerLinkto(componentId) {
        const pathName = this.props.history.location.pathname;

        if (pathName !== "/") {
            this.props.history.push(``, { componentId });
        }
        else {
            ScrollTo(componentId);
        }
    }


    handleCloseModal() {
        this.setState({ openModal: false });
    }

    handleOpenModal() {
        this.setState({ openModal: true });
    }

    render() {
        const { openModal } = this.state;
        return (

            <Fragment>
                <div className="container-fluid footer">
                    <nav className="container">
                        <ul className="footer-menu">
                            <li onClick={() => this.handlerLinkto('PublishingCompany')} className="footer-menu-item" >  A EDITORA  </li>
                            <li onClick={() => this.handlerLinkto('Authors')} className="footer-menu-item" >  AUTORES    </li>
                            <li onClick={() => this.handlerLinkto('newBooks')} className="footer-menu-item" >  LIVROS     </li>
                            <li onClick={() => this.handlerLinkto('Publish')} className="footer-menu-item" >  PUBLIQUE   </li>
                            <li onClick={() => this.handlerLinkto('Contact')} className="footer-menu-item" >  CONTATO    </li>
                        </ul>
                    </nav>
                    <div className="footer-infos" >
                        <figure className="footer-infos-sociais" >
                                <a target="blank" href="https://facebook.com/a5editora">
                                    <img className="icon-sociais facebook" src={facebook} alt="" />
                                </a>
                                <a target="blank" href="https://instagram.com/a5editora?utm_source=ig_profile_share&igshid=uv77n98kxjaf"> <img className="icon-sociais instagram" src={instagram} alt="" />
                                </a>
                        </figure>
                        <p style={{ marginBottom: 0 }} className="text-center colorWhite" ><a href="mailto:contato@a5editora.com.br" className="mail">contato@a5editora.com.br</a></p>
                        <p style={{ marginBottom: 0 }} className="text-center colorWhite" >© 2019, A5 Editora Gráfica e Agência Editorial LTDA. | CNPJ 13.417.297/0001-37</p>
                        <p style={{ marginBottom: 0 }} className="text-center colorWhite" >(73) 99142-7446</p>
                    </div>

                </div>
                <div className="footer-two">
                    <div className="container footer-two-content">
                        <div style={{ width: '10%' }}></div>
                        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between' }}>
                            <span onClick={this.handleOpenModal} className="footer-two-item">Nossas políticas de uso</span>
                        </div>
                        <a style={{ cursor: 'pointer' }} target="blank" href="http://www.uxmob.com.br"><img className="footer-two-logo" src={logoUXMob} alt="" /></a>
                    </div>
                </div>
                <Modal open={openModal} onClose={this.handleCloseModal} >
                    <div className="footer-modal">
                        <h1>Nossas Políticas de Uso</h1>
                        <h2>POLÍTICAS DE PRIVACIDADE</h2>
                        <p>Utilizamos um moderno sistema de codificação e tecnologia avançada para transações online, com o intuito de garantir que sua compra seja feita com segurança.
                        </p>
                        <p>
                            Para efetuar compras em nosso site, serão solicitados alguns dados cadastrais, tais como: nome completo, RG e/ou CPF, endereço e telefones de contato. O cliente desde já concorda em fornecer tais dados cadastrais tendo em vista serem essenciais para a formalização da compra. O endereço cadastrado é utilizado apenas para o envio dos produtos adquiridos, sendo que nenhuma correspondência será enviada sem a sua solicitação.
                        </p>
                        <p>
                            Para concluir o pedido, serão solicitadas informações financeiras conforme a forma de pagamento escolhida.
                        </p>
                        <p>Ao optar pelo pagamento com cartão de crédito, você deverá informar o número do cartão, o código de segurança, a data de vencimento e a operadora. Para sua segurança, estas informações não serão mantidas em nosso banco de dados, sendo necessário informá-las novamente em todas as compras. Nessas transações, o processo de aprovação é feito diretamente com as Administradoras de Cartões, Bancos e intermediadores de pagamentos.
                        </p>
                        <h3>Compartilhamento de informações</h3>
                        <p>A editora não comercializa ou empresta informações de seu banco de dados para outra empresa, instituição ou associação. No entanto, faz-se necessário o compartilhamento de informações com empresas parceiras, sob total sigilo e privacidade, para a prestação de serviços como: entrega dos itens adquiridos, cobrança, envio de e-mails, análise de banco de dados ou processamento de transações por meio de cartão de crédito. Além de tais motivos, os referidos dados somente poderão ser revelados em caso de requerimento de autoridade pública administrativa ou judicial.
                        </p>
                        <h3>Exclusão definitiva dos dados cadastrais.
                        </h3>
                        <p>O usuário pode optar por solicitar a exclusão definitiva dos seus dados cadastrais do banco de dados da editora entrando em contato através do e-mail: contato@a5editora.com.br Após a solicitação o descadastro será efetuado em  até 15 dias úteis.
                        </p>
                        <h3>Código de defesa do consumidor</h3>
                        <p>Consulte o código de defesa do consumidor no link abaixo:
                        </p>
                        <a target="_blank" href="http://www.planalto.gov.br/ccivil_03/Leis/L8078.htm">http://www.planalto.gov.br/ccivil_03/Leis/L8078.htm</a>
                        <h2>POLÍTICAS DE USO </h2>
                        <h3>SOBRE PAGAMENTOS</h3>
                        <h4>Confirmação do pagamento</h4>
                        <span>Os prazos para confirmação de pagamento são:
                        </span>
                        <span>Cartão de Crédito = até 48 horas.
</span>
                        <span> Após a aprovação do pagamento, seu pedido será enviado para o endereço informado.
</span>
                        <span>Os prazos podem ser maiores se houver problemas de sistema, grande fluxo de transações, entre outras situações atípicas.
</span>
                        <h3>Formas de pagamento
</h3>
                        <h4>Cartão de crédito:
                    </h4>
                        <span>
                           <strong>Visa; Master; Elo; Amex; Hiper, JCB, Dinners & Discover.</strong>
                        </span>
                        <p>Obs: O cartão de crédito deverá ter sido emitido no Brasil, portanto não serão aceitos cartões de crédito emitidos no exterior.
</p>
                        <p>Para sua segurança, todos os pedidos estão sujeitos à análise e confirmação dos dados cadastrais e de entrega. Esta confirmação, quando necessária, será feita através de contato telefônico, e visa exclusivamente garantir a identidade do comprador e evitar qualquer dano ou prejuízo aos nossos clientes.
</p>

                        <h4>Finalização da compra</h4>
                        <p>Após a finalização da compra, não será permitida a alteração dos dados do pedido tais como: inclusão de produtos ou exclusão de produtos, mudança do endereço de entrega, alteração da forma de pagamento.</p>

                        <p>Nesta modalidade o prazo de entrega dos correios é de até 15 dias úteis.
    Caso não receba sua encomenda no prazo previsto envie um e-mail para contato@a5editora.com.br
</p>

                        <h4>Políticas de cancelamento e arrependimento</h4>
                        <p> Caso encontre problemas no livro envie um email para contato@a5editora.com.br explicando o por que da troca e a foto do problema. Teremos até 4 dias úteis para avaliar a situação e enviar um novo livro para o mesmo endereço que o primeiro foi enviado. Concluindo que houve problemas pode haver reembolso do valor integral.</p>

                        <p><strong>Importante: </strong> Havendo extravio os correios informam que não tem como reaver o produto. Nessa condição a editora informará ao cliente e enviará um novo produto.
</p>           <p>Caso resida em Itabuna a entrega será via motoboy no endereço informado e não haverá custo em um raio de 7km. </p>

                    <h3>PRÉ-VENDA</h3>

                    <p>A pré-venda é uma modalidade de compra onde você reserva um produto que ainda não está disponível no mercado.
A editora garante que o cliente receberá o produto após a data de lançamento do mesmo, sendo a cobrança  realizada no ato de confirmação da compra.
Todos os livros em pré-venda, aparecerão na página principal na Aba PRÉ-VENDA
</p>

    {
      /*
      <h4>WEB LIVRO</h4>
      <p>A editora criou a plataforma “WebLivro” onde alguns livros estarão disponíveis a um preços mais acessível de forma que o usuário poderá ter acesso instantâneo ao conteúdo do mesmo. O pagamento se dará nas mesmas condições do livro impresso.
Para esta modalidade de acesso será necessário o cadastro do cliente com as seguintes informações: Nome completo, e-mail, telefone fixo, celular e senha.
</p>
      */
    }
                    </div>

                </Modal>
            </Fragment>

        );
    }

}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js